angular.module('impactx.product').controller('ProductAttributesCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'data',
    'headerLabel',
    'confirmLabel',
    'abortLabel',
    'requiredLabel',
    'noSelectedItemMessage',
    'trns',
    'freeSelectionMessage',
    ProductAttributesCtrl]);

function ProductAttributesCtrl($scope, $mdDialog, themeFactory, dataGen, data, headerLabel, confirmLabel, abortLabel, requiredLabel, noSelectedItemMessage, trns, freeSelectionMessage) {
    $scope.showMust = true;
    $scope.readOnly = data.readOnly;
    $scope.theme = themeFactory.getTheme();
    //copy main data so we can revert it.
    $scope.attributeData = JSON.parse(JSON.stringify(data.attributeData));
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.headerLabel = headerLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.freeSelectionMessage = freeSelectionMessage;
    $scope.trns = trns;

    if (!$scope.attributeData.removedAttributes) {
        $scope.attributeData.removedAttributes = [];
    }
    if (!$scope.attributeData.newAttributes) {
        $scope.attributeData.newAttributes = [];
    }
    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.confirm = function () {
        data.attributeData = $scope.attributeData;
        $mdDialog.hide();
    };

    this.addAttribute = function () {
        $scope.attributeData.newAttributes.push({});
    };

    this.removeNewAttribute = function (index) {
        $scope.attributeData.newAttributes.splice(index, 1);
    };

    this.removeAttribute = function (index) {
        $scope.attributeData.removedAttributes.push($scope.attributeData.attributes.splice(index, 1)[0]);
    };

    this.onPatSelect = function (selected, baseObject, searchText) {
        if (!baseObject.freeSelection) {
            baseObject.freeSelection = {value: null};
        }
        if (!selected || !selected.id) {
            baseObject.freeSelection.value = searchText;
        }
        else {
            baseObject.freeSelection.value = null;
            dataGen.getData({}, {patId: selected.id}, "/product/inputforpat").then(function (data) {
                baseObject.stringSettings = data.data.stringSettings;
                baseObject.booleanSettings = data.data.booleanSettings;
                baseObject.doubleSettings = data.data.doubleSettings;
                baseObject.integerSettings = data.data.integerSettings;
                baseObject.enumSettings = data.data.enumSettings;
            });
        }
    };

    this.getPatList = function (searchText) {
        return dataGen.getData({}, {searchText: searchText}, "/product/patpopup", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.patSearchTextChanged = function (selected, searchText, baseObject) {
        if (!baseObject.freeSelection) {
            baseObject.freeSelection = {value: null};
        }
        if (!selected || !selected.id) {
            baseObject.freeSelection.value = searchText;
            if (baseObject.stringSettings) {
                baseObject.stringSettings[0].label = searchText;
            }
            else {
                baseObject.stringSettings = [{paiId: 0, patId: 0, label: searchText, value: ""}];
            }
        }
        else {
            baseObject.freeSelection.value = null;
        }
    };

    this.setSelected = function (selected) {
        if (selected && selected.id) {
            $scope.selectedEClass = {
                value: selected.value.substring(0, 8)
            }
        }
    };
}